import { CircularProgress, Fab, IconButton, Popper, Typography } from '@material-ui/core'
import { PlayArrow, Clear, PauseOutlined, VolumeUp } from '@material-ui/icons'
import React, { useState, useEffect, useRef } from 'react'
import VolumeComponent from './VolumeComponent';

interface AudioComponentProps {
    StreamID: any;
}

function AudioComponent({StreamID}: AudioComponentProps) {
    const [Loading, setLoading] = useState(false)
    const [Pause, setPause] = useState(false);
    const [Playing, setPlaying] = useState(false);
    const [Error, setError] = useState(false);
    const [Volume, setVolume] = useState(50)
    const [Timer, setTimer] = useState(0)
    const [anchorEl, setanchorEl] = useState<any>(null)
    const audioRef = useRef<HTMLAudioElement>(null);
    const open = Boolean(anchorEl);
    const hasStream = Boolean(StreamID?.id);

    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.volume = Volume / 100;
        }
    }, [Volume])

    useEffect(() => {
        (audioRef.current as any).referrerPolicy = "no-referrer";
    }, [])

    useEffect(() => {
        if (Error || !Pause) {
            setTimer(0);
            return;
        }
        if (Timer < 40) {
            const t = setTimeout(() => setTimer(Timer + 1), 1000);
            return () => clearTimeout(t);
        }
    }, [Timer, Error, Pause])

    const handlePlayPause = async () => {
        if (!audioRef.current || !hasStream) return;
        if (!Pause) {
            try {
                await audioRef.current.play();
                setPause(true);
                setError(false);
            } catch {
                setError(true);
            }
        } else {
            audioRef.current.pause();
            setPause(false);
        }
    }

    return (
        <div className="audioContainer">
            <audio
                hidden
                id="audioplayer"
                ref={audioRef}
                src={StreamID.id}
                onPlaying={() => setPlaying(true)}
                onPause={() => setPlaying(false)}
                onError={() => setError(true)}
                onLoad={() => setLoading(true)}
                onLoadedData={() => setLoading(false)}
            />
            <Fab onClick={handlePlayPause}>
                {!Pause ? <PlayArrow color="secondary" /> : <PauseOutlined color="secondary" />}
            </Fab>
            <div className="Tags">
                <div>
                    {Error ? <Typography color="error" style={{ fontSize: "14px", fontWeight: "bold" }}>
                        {Timer >= 40 ? "Error ID Transmision invalido." : "La transmision no esta disponible ahora."}
                    </Typography> : Pause ? <Typography color="primary" style={{ fontSize: "14px", fontWeight: "bold" }}>
                        {Playing ? "Reproduciendo ahora..." : "Buscando señal..." }
                    </Typography> : <Typography color="primary" style={{ fontSize: "14px", fontWeight: "bold" }}>
                        Listo para reproducir.
                    </Typography>}
                    <Typography color="primary" style={{ fontSize: "12px"  }}>
                        Audio En Vivo
                    </Typography>
                    <Typography color="primary" style={{ fontSize: "12px"  }}>
                        Radio Frontina 100.3 FM
                    </Typography>
                </div>
                <Popper open={open} style={{ zIndex: "120" as any}} anchorEl={anchorEl} placement="top">
                    <VolumeComponent changeState={(value: number) => setVolume(value)} value={Volume} />
                </Popper>
                    <IconButton color="primary" size="small" onClick={(e) => setanchorEl(open ? null : e.target)}>
                        <VolumeUp color="primary" />
                    </IconButton>
                {Playing && <div className="spinner">
                    <div className="double-bounce1"></div>
                    <div className="double-bounce2"></div>
                </div>}
                {Pause && !Playing && !Error && <CircularProgress size={20} style={{ margin: "5px"}} />}
            </div>

        </div>
    )
}

export default React.memo(AudioComponent)
